<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Purchase Order #{{purchaseOrder.code}}</h4>
                    <p class="text-subtitle-1">Purchase Order Display</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(perm.purchase_order.read)">
                    <v-btn block depressed @click="handlePrint" :loading="printLoading">
                        <v-icon left>mdi-printer</v-icon>
                        print
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.purchase_order.update)">
                    <v-btn block depressed @click="handleEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="3">
                    <v-menu
                        offset-y
                        min-width="250"
                        v-if="filteredMenu.length > 0"
                    >
                        <template v-slot:activator="{ attrs, on }">
                            <v-btn
                            text
                            block
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon left>
                                    mdi-dots-vertical
                                </v-icon>
                                actions
                            </v-btn>
                        </template>
                        <v-list
                            dense
                            flat
                            outlined
                        >
                            <v-list-item v-for="(d, i) in filteredMenu" @click="d.callback" :key="i" link >
                                <v-list-item-icon>
                                    <v-icon>{{d.icon}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{d.title}}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <PurchaseOrder :value="purchaseOrder"/>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>

        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PAlert from './../../components/common/PAlert.vue'
import PurchaseOrder from './../../components/purchase/PurchaseOrder.vue';
import { mapActions, mapGetters } from 'vuex';
import orderAPI from '../../services/purchase/order.js'

export default {
    name: "PurchaseOrderDisplayView",
    components: {
        PurchaseOrder,
        PAlert
    },
    data() {
        return {
            id: null,
            loading: false,
            printLoading: false,
            purchaseOrder: {},
            alert:{
                value: false,
                content: 'Are you sure',
                callback: null
            },
            perm: permissions,

        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        }),
        filteredMenu() {
            return this.menu.filter(f => f.permission == true)
        },
        menu() {
            return [
                {
                    icon: "mdi-gesture-tap-button",
                    callback: this.navigateToInvoice,
                    title: "Make Invoice",
                    permission: this.hasPermission(this.perm.invoice.create)
                },
                {
                    icon: "mdi-archive",
                    callback: this.makeGoodsReceipt,
                    title: "Make Good Receipt",
                    permission: this.hasPermission(this.perm.po_good_receipt.create)
                },
                {
                    icon: "mdi-export",
                    callback: this.makeGoodReturn,
                    title: "Make Good Return",
                    permission: this.hasPermission(this.perm.good_return.create)
                },
                {
                    icon: "mdi-circle-box",
                    callback: this.makeGeneralReceipt,
                    title: "Make General Receipt",
                    permission: this.hasPermission(this.perm.general_receipt.create)
                },
                {
                    icon: "mdi-alert-octagon-outline",
                    callback: this.handleClose,
                    title: "Close",
                    permission: this.hasPermission(this.perm.purchase_order.close)
                }
            ]
        }
    },
    methods: {
        ...mapActions({
            findByID: "purchase/order/findByID",
            close: "purchase/order/close",
            snackbar: "ui/snackbar/show"
        }),
        getPurchaseOrder() {
            this.loading = true;
            this.findByID(this.id).then(response => {
                this.purchaseOrder = response.data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCreateOrder() {
            this.$router.push({name: "PurchaseOrderCreate"})
        },
        handleList() {
            this.$router.push({name: "PurchaseOrderList"})
        },
        handleEdit() {
            this.$router.push({ name: "PurchaseOrderEdit", params: { id: this.id } })
        },
        navigateToInvoice() {
            this.$router.push({ name: "PurchaseInvoiceCreate", query: {
                order_id: this.id
            }})
        },
        makeGoodsReceipt() {
            this.$router.push({ name: "GoodReceiptCreate", query: {
                order_id: this.id
            }})
        },
        makeGeneralReceipt() {
            this.$router.push({ name: "GeneralReceiptCreate", query: {
                order_id: this.id
            }})
        },
        handleClose() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to close this purchase order?", callback: this.closeAsync}
        },
        closeAsync() {
            this.loading = true;
            this.close(this.purchaseOrder).then(response => {
                this.purchaseOrder = response.data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.loading = false;
            })
        },
        makeGoodReturn() {
            this.$router.push({ name: "GoodReturnCreate", query: {
                order_id: this.id
            }})
        },
        handlePrint() {
            this.printLoading = true;
            orderAPI.print(this.id)
                .then(response => {
                    var printWindow = window.open('','','width=800,height=600');
                    printWindow.document.write(response.data);
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                    printWindow.close();
                })
                .catch(error => {
                    let message = error.response ? error.response.data.message : error;
                    this.snackbar = { value: true, color: "error", text: message }
                }).finally(() => {
                    this.printLoading = false;
                });
        },
    },
    mounted() {
        this.id = this.$route.params.id;
        this.getPurchaseOrder();
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getPurchaseOrder();
        next();
    }
}
</script>

<style>

</style>